import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export const statement = () => {

	const els = document.querySelectorAll('[data-animation="statement"]')

	if (!els.length || window.innerWidth < 782) return false

	document.fonts.ready.then(() => {
		els.forEach(el => {

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: el.parentElement,
					start: 'center bottom',
					end: 'center center',
					ease: 'none',
					scrub: 1.5,
					// markers: true,
				}
			})

			let paras = el.querySelectorAll('[data-text]')

			paras.forEach(para => {

				let split = new SplitText(para, {
					type: 'lines',
				})

				para.removeAttribute('aria-label')

				split.lines.forEach(line => {
					tl.fromTo(line, {
						clipPath: 'polygon(0 -15%, 0 -15%, 0 115%, 0 115%)',
					}, {
						clipPath: 'polygon(0 -15%, 100% -15%, 100% 115%, 0 115%)',
					})
				})

			})

		})
	})

}

export default () => { }